import { useState } from 'react';

/**
 * Hook that generates a random number between 0 and `max` (both inclusive).
 * The random number is generated once on initial render and remains stable across re-renders.
 * @param max The maximum value of the random number (inclusive).
 * @param options
 * @param options.randomFn The function to use for generating the random number. Defaults to `Math.random`.
 */
export const useRandomNumber = (max: number, options?: { randomFn?: () => number }): number => {
	const [number] = useState(() => {
		const rng = options?.randomFn ?? Math.random;
		if (max < 0) {
			return 0;
		}
		return Math.floor(rng() * (max + 1));
	});

	return number;
};
